import {
    FETCHED_BLOCKS,
    FETCHED_BLOCK,
    UPDATED_BLOCK,
    DELETED_BLOCK,
    FETCHED_BLOCK_TYPES,
    FETCHED_BLOCK_REVISIONS,
    FETCHED_BLOCK_TRANSLATIONS,
    FETCHED_BLOCK_SITE_TRANSLATION,
    DELETED_BLOCK_REVISION,
    DELETED_BLOCK_TRANSLATION,
    UPDATED_BLOCK_TRANSLATION,
    DISABLED_BLOCK,
    ENABLED_BLOCK,
    DISABLED_TRANSLATION,
    ENABLED_TRANSLATION,
    FETCHED_TRANSLATION_REVISIONS,
    ACTIVATED_BLOCK_REVISION,
    ACTIVATED_TRANSLATION_REVISION,
    FETCHED_BLOCKS_BY_TERMS,
    BLOCK_SEARCH_BY_TITLE,
    ADD_IMAGES_IN_BLOCK_EDIT,
    ADD_BLOCK_IMAGE_SETTING,
    ADD_BLOCK_VIDEO_SETTING,
    REMOVE_BLOCK_IMAGE,
    UPDATE_BLOCK_CROPPED_IMAGE,
    UPDATE_BLOCK_IMAGE_META,
    UPDATE_BLOCK_THUMB_CROPPED_IMAGE,
    UPDATE_BLOCK_IMAGES_SORT_ORDER,
    SELECT_BLOCK_TYPE,
    SELECT_BLOCK_NAME,
    SELECT_BLOCK_DESTINATION,
    SELECT_BLOCK_TRIP_FORMAT,
    SELECT_BLOCK_TYPE_OF_WORK,
    SELECT_BLOCK_TITLE,
    SELECT_BLOCK_BODY,
    SELECT_BLOCK_BUTTON_TEXT,
    UPDATE_VIDEO_URL_FIELD,
    TOGGLE_PAGE_PICKER_POPUP,
    PICK_BLOCK_PAGE,
} from './types';
import update from 'immutability-helper';
import shortid from 'shortid';
import _findIndex from 'lodash/findIndex';
import _sortBy from 'lodash/sortBy';

const INITIAL_STATE = {
    all: [],
    blockSearchCriteria: '',
    allByTerms: [],
    allByTermsPageId: undefined,
    allBlockTypes: [],
    allBlockRevisions: [],
    allBlockTranslations: [],
    allTranslationRevisions: [],
    block: {
        images: [],
        imageSettings: [],
        videos: [],
        videoSettings: [],
    },
    blockName: '',
    approvedBlockRevision: {},
    blockSiteTranslation: {},
    approvedTranslationRevision: {},
    touched: false,
    pagePicker: {
        popupOpen: false,
        page: {},
    },
};

export default function(state = INITIAL_STATE, action) {
    let toEditSettingPosition;

    switch (action.type) {
        case BLOCK_SEARCH_BY_TITLE:
            return update(state, {
                blockSearchCriteria: {$set: action.payload.searchBy},
            });

        case FETCHED_BLOCKS:
            return update(state, {
                all: {$set: action.payload.data},
                block: {
                    $set: {
                        images: [],
                        imageSettings: [],
                        videos: [],
                        videoSettings: [],
                    },
                },
            });

        case FETCHED_BLOCKS_BY_TERMS:
            return update(state, {
                allByTerms: {$set: action.payload.blocks},
                allByTermsPageId: {$set: action.payload.pageId},
            });

        case FETCHED_BLOCK:
            return update(state, {
                block: {$set: action.block},
                blockName: {$set: action.block.display_name},
                pagePicker: {
                    page: {$set: action.block.page},
                },
            });

        case UPDATED_BLOCK:
            return update(state, {
                block: {$set: action.block},
                touched: {$set: action.touched},
            });

        case DELETED_BLOCK:
            let allBlocks = state.all.filter(
                (item) => item.id !== action.block
            );

            return update(state, {
                all: {$set: allBlocks},
            });

        case SELECT_BLOCK_TYPE:
            return update(state, {
                block: {
                    block_type_id: {$set: action.blockTypeId},
                },
                touched: {$set: action.touched},
            });

        case UPDATE_VIDEO_URL_FIELD:
            let videoObjects = [];
            videoObjects[0] = {id: action.id, url: action.url};

            return update(state, {
                block: {
                    videos: {$set: videoObjects},
                },
                touched: {$set: action.touched},
            });

        case SELECT_BLOCK_DESTINATION:
            return update(state, {
                block: {
                    destination_id: {$set: action.blockDestinationId},
                },
                touched: {$set: action.touched},
            });

        case SELECT_BLOCK_TRIP_FORMAT:
            return update(state, {
                block: {
                    trip_format_id: {$set: action.blockTripFormatId},
                },
                touched: {$set: action.touched},
            });

        case SELECT_BLOCK_TYPE_OF_WORK:
            return update(state, {
                block: {
                    type_of_work_id: {$set: action.blockTypeOfWorkId},
                },
                touched: {$set: action.touched},
            });

        case SELECT_BLOCK_NAME:
            return update(state, {
                block: {
                    display_name: {$set: action.name},
                },
                touched: {$set: action.touched},
            });

        case SELECT_BLOCK_TITLE:
            return update(state, {
                block: {
                    title: {$set: action.title},
                },
                touched: {$set: action.touched},
            });

        case SELECT_BLOCK_BODY:
            return update(state, {
                block: {
                    body: {$set: action.body},
                },
                touched: {$set: action.touched},
            });

        case SELECT_BLOCK_BUTTON_TEXT:
            return update(state, {
                block: {
                    button_text: {$set: action.button_text},
                },
                touched: {$set: action.touched},
            });

        case DISABLED_BLOCK:
            let indexDisabledBlock = state.all.findIndex(
                (item) => item.id === action.block
            );

            return update(state, {
                all: {
                    [indexDisabledBlock]: {$merge: {is_enabled: 0}},
                },
            });

        case ENABLED_BLOCK:
            let indexEnabledBlock = state.all.findIndex(
                (item) => item.id === action.block
            );

            return update(state, {
                all: {
                    [indexEnabledBlock]: {$merge: {is_enabled: 1}},
                },
            });

        case DISABLED_TRANSLATION:
            let indexDisabledBlockTranslation = state.allBlockTranslations.findIndex(
                (item) => item.id === action.payload
            );

            return update(state, {
                allBlockTranslations: {
                    [indexDisabledBlockTranslation]: {$merge: {is_enabled: 0}},
                },
            });

        case ENABLED_TRANSLATION:
            let indexEnabledBlockTranslation = state.allBlockTranslations.findIndex(
                (item) => item.id === action.payload
            );

            return update(state, {
                allBlockTranslations: {
                    [indexEnabledBlockTranslation]: {$merge: {is_enabled: 1}},
                },
            });

        case FETCHED_BLOCK_TYPES:
            let sortedBlockTypes = _sortBy(action.blockTypes, 'display_name');

            return update(state, {
                allBlockTypes: {$set: sortedBlockTypes},
            });

        case FETCHED_BLOCK_TRANSLATIONS:
            return update(state, {
                allBlockTranslations: {$set: action.blockTranslations},
            });

        case FETCHED_BLOCK_SITE_TRANSLATION:
            return update(state, {
                blockSiteTranslation: {$set: action.blockTranslation},
                pagePicker: {
                    page: {$set: action.blockTranslation.page},
                },
            });

        case UPDATED_BLOCK_TRANSLATION:
            return update(state, {
                blockSiteTranslation: {$set: action.blockTranslation},
                touched: {$set: action.touched},
            });

        case DELETED_BLOCK_TRANSLATION:
            let allTranslations = state.allBlockTranslations.filter(
                (item) => item.id !== action.translation
            );

            return update(state, {
                allBlockTranslations: {$set: allTranslations},
            });

        case FETCHED_BLOCK_REVISIONS:
            let activeRevision;
            action.blockRevisions.forEach((revision) => {
                return revision.active === 1
                    ? (activeRevision = revision.id)
                    : null;
            });

            return update(state, {
                allBlockRevisions: {$set: action.blockRevisions},
                approvedBlockRevision: {$set: activeRevision},
            });

        case ACTIVATED_BLOCK_REVISION:
            return update(state, {
                approvedBlockRevision: {$set: action.revisionId},
            });

        case DELETED_BLOCK_REVISION:
            let allRevisions = state.allBlockRevisions.filter(
                (item) => item.id !== action.revision
            );

            return update(state, {
                allBlockRevisions: {$set: allRevisions},
            });

        case FETCHED_TRANSLATION_REVISIONS:
            let activeTranslationRevision;
            action.translationRevisions.forEach((revision) => {
                return revision.active === 1
                    ? (activeTranslationRevision = revision.id)
                    : null;
            });

            return update(state, {
                allTranslationRevisions: {$set: action.translationRevisions},
                approvedTranslationRevision: {$set: activeTranslationRevision},
            });

        case ACTIVATED_TRANSLATION_REVISION:
            return update(state, {
                approvedTranslationRevision: {$set: action.revisionId},
            });

        case ADD_IMAGES_IN_BLOCK_EDIT:
            let imgs = [];

            if (!action.payload instanceof Array) {
                imgs = [action.payload.images];
            } else {
                imgs = action.payload.images;
            }

            let imageObjects = [];

            for (let i in imgs) {
                imageObjects[i] = {
                    id: shortid.generate(),
                    url: imgs[i].preview,
                    preview: imgs[i].preview,
                    alt: '',
                    title: '',
                    description: '',
                    link: '',
                    filename: imgs[i].name,
                    name: imgs[i].name,
                    new: true,
                    deleted: false,
                    imageObject: imgs[i],
                    croppedImage: null,
                    croppedImageObject: null,
                    croppedImageThumb: null,
                    croppedImageThumbObject: null,
                    croppedImageRatioId: null,
                };
            }

            return update(state, {
                block: {images: {$push: imageObjects}},
                touched: {$set: action.payload.touched},
            });

        case ADD_BLOCK_IMAGE_SETTING:
            toEditSettingPosition = _findIndex(state.block.imageSettings, {
                id: action.payload.forSetting.id,
            });

            if (toEditSettingPosition < 0) {
                return update(state, {
                    block: {
                        imageSettings: {
                            $push: [
                                {
                                    id: action.payload.forSetting.id,
                                    name: action.payload.forSetting.name,
                                    options: action.payload.selectedOptions,
                                },
                            ],
                        },
                    },
                    touched: {
                        $set: action.payload.touched,
                    },
                });
            } else {
                return update(state, {
                    block: {
                        imageSettings: {
                            [toEditSettingPosition]: {
                                options: {$set: action.payload.selectedOptions},
                            },
                        },
                    },
                    touched: {$set: action.payload.touched},
                });
            }

        case ADD_BLOCK_VIDEO_SETTING:
            toEditSettingPosition = _findIndex(state.block.videoSettings, {
                id: action.payload.forSetting.id,
            });

            if (toEditSettingPosition < 0) {
                return update(state, {
                    block: {
                        videoSettings: {
                            $push: [
                                {
                                    id: action.payload.forSetting.id,
                                    name: action.payload.forSetting.name,
                                    options: action.payload.selectedOptions,
                                },
                            ],
                        },
                    },
                    touched: {
                        $set: action.payload.touched,
                    },
                });
            } else {
                return update(state, {
                    block: {
                        videoSettings: {
                            [toEditSettingPosition]: {
                                options: {$set: action.payload.selectedOptions},
                            },
                        },
                    },
                    touched: {$set: action.payload.touched},
                });
            }

        case REMOVE_BLOCK_IMAGE:
            return update(state, {
                block: {
                    images: {[action.payload.index]: {$merge: {deleted: true}}},
                },
                touched: {$set: action.payload.touched},
            });

        case UPDATE_BLOCK_CROPPED_IMAGE:
            return update(state, {
                block: {
                    images: {
                        [action.payload.index]: {
                            $merge: {
                                croppedImage: action.payload.imageUrlBlob,
                                croppedImageObject:
                                    action.payload.imageBlobObject,
                            },
                        },
                    },
                },
                touched: {$set: action.payload.touched},
            });

        case UPDATE_BLOCK_IMAGE_META:
            return update(state, {
                block: {
                    images: {
                        [action.payload.index]: {
                            $merge: {
                                alt: action.payload.imageMeta.alt,
                                title: action.payload.imageMeta.title,
                                description:
                                    action.payload.imageMeta.description,
                                link: action.payload.imageMeta.link,
                                filename: action.payload.imageMeta.name,
                                name: action.payload.imageMeta.name,
                            },
                        },
                    },
                },
                touched: {$set: action.payload.touched},
            });

        case UPDATE_BLOCK_THUMB_CROPPED_IMAGE:
            return update(state, {
                block: {
                    image: {
                        $merge: {
                            croppedImageThumb: action.payload.imageUrlBlob,
                            croppedImageThumbObject:
                                action.payload.imageBlobObject,
                        },
                    },
                },
                touched: {$set: action.payload.touched},
            });

        case UPDATE_BLOCK_IMAGES_SORT_ORDER:
            return update(state, {
                block: {images: {$set: action.payload.images}},
                touched: {$set: action.payload.touched},
            });

        case TOGGLE_PAGE_PICKER_POPUP:
            return update(state, {
                pagePicker: {
                    popupOpen: {$set: !state.pagePicker.popupOpen},
                },
            });

        case PICK_BLOCK_PAGE:
            return update(state, {
                pagePicker: {
                    page: {
                        $set: {
                            id: action.payload.pageId,
                            title: action.payload.pageTitle,
                        },
                    },
                },
                touched: {$set: action.payload.touched},
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/blocks/reducer.js